document.querySelectorAll('#mainContent h2').forEach(h2 => {
  const match = h2.textContent.match(/\(([^)]+)\)/);
  if (match) {
    const span = document.createElement('span');
    span.className = 'text-nowrap';
    span.textContent = match[0];
    h2.innerHTML = h2.innerHTML.replace(match[0], span.outerHTML);
  }
});
document.querySelectorAll('#mainContent h3').forEach(h3 => {
  const match = h3.textContent.match(/\(([^)]+)\)/);
  if (match) {
    const span = document.createElement('span');
    span.className = 'text-nowrap';
    span.textContent = match[0];
    h3.innerHTML = h3.innerHTML.replace(match[0], span.outerHTML);
  }
});